import React, { memo } from "react";
import { Handle, Position } from "@xyflow/react";
import { Http } from "@mui/icons-material";
import NodeWrapper from "./NodeWrapper";

const METHOD_COLORS = {
  GET: "#4caf50",
  POST: "#2196f3",
  PUT: "#ff9800",
  DELETE: "#f44336",
};

const HttpRequestNode = memo(({ id, data, isConnectable, selected }) => {
  const method = data?.method || "GET";
  const url = data?.url || "";
  const saveVars = data?.saveVariables;
  const varCount = Array.isArray(saveVars) ? saveVars.length : 0;

  return (
    <NodeWrapper
      id={id}
      data={data}
      icon={<Http />}
      title="Requisicao HTTP"
      color="#0277BD"
      bgColor="#E1F5FE"
      noTarget
      noSource
      isConnectable={isConnectable}
      selected={selected}
      minWidth={220}
    >
      {/* Custom target handle */}
      <Handle
        type="target"
        position={Position.Left}
        id="httpRequest-in"
        style={{
          background: "#0277BD",
          width: 14,
          height: 14,
          left: -8,
          border: "2px solid #E1F5FE",
          borderRadius: "50%",
          cursor: "crosshair",
        }}
        isConnectable={isConnectable}
      />

      {/* Method + URL row */}
      <div style={{ display: "flex", alignItems: "center", gap: 6, marginBottom: 4 }}>
        <span
          style={{
            fontSize: 10,
            fontWeight: 800,
            color: "#fff",
            backgroundColor: METHOD_COLORS[method] || "#666",
            padding: "2px 8px",
            borderRadius: 4,
            letterSpacing: "0.04em",
            flexShrink: 0,
          }}
        >
          {method}
        </span>
        <span
          style={{
            fontSize: 10,
            color: "#37474F",
            fontFamily: "'JetBrains Mono', 'Fira Code', 'Consolas', monospace",
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
            flex: 1,
            maxWidth: 150,
          }}
        >
          {url || "URL nao definida"}
        </span>
      </div>

      {/* Variable count */}
      {varCount > 0 && (
        <div
          style={{
            fontSize: 10,
            color: "#0277BD",
            display: "flex",
            alignItems: "center",
            gap: 4,
          }}
        >
          <span
            style={{
              width: 6,
              height: 6,
              borderRadius: "50%",
              backgroundColor: "#0277BD",
              display: "inline-block",
            }}
          />
          {varCount} variave{varCount === 1 ? "l" : "is"} salva{varCount === 1 ? "" : "s"}
        </div>
      )}

      {/* Preset */}
      {data?.presetName && (
        <div style={{ fontSize: 9, color: "#78909C", marginTop: 2 }}>
          Preset: {data.presetName}
        </div>
      )}

      {/* Custom source handle */}
      <Handle
        type="source"
        position={Position.Right}
        id="httpRequest-out"
        style={{
          background: "#0277BD",
          width: 14,
          height: 14,
          right: -8,
          border: "2px solid #E1F5FE",
          borderRadius: "50%",
          cursor: "crosshair",
        }}
        isConnectable={isConnectable}
      />
    </NodeWrapper>
  );
});

HttpRequestNode.displayName = "HttpRequestNode";
export default HttpRequestNode;
